export default __webpack_public_path__ + "static/media/edit.816112d0.svg";